import { put, takeLeading } from 'redux-saga/effects';

import { logger } from '@/config/logger';
import { exportSecrets } from '@/modules/api/codegen';
import { actions as messagesActions } from '@/modules/messages';

import { EXPORT_FILE_NAME, SUPPORTED_FILE_MIME } from '../../constants';
import { exportRequest, exportRequestFailure, exportRequestSuccess } from '../actions';

function* exportHandler() {
    try {
        const { data } = yield exportSecrets({
            responseDataType: 'blob',
            headers: {
                accept: SUPPORTED_FILE_MIME,
            },
        });

        const { default: downloadFile } = yield import('js-file-download');

        downloadFile(data, EXPORT_FILE_NAME, SUPPORTED_FILE_MIME);

        yield put(exportRequestSuccess());
    } catch (e) {
        yield put(
            messagesActions.displayErrorMessage({
                message: { id: 'error.import-export.export' },
            }),
        );
        logger.error(e);

        yield put(exportRequestFailure());
    }
}

export default function* exportSaga() {
    yield takeLeading(exportRequest.toString(), exportHandler);
}
